module.exports = __webpack_public_path__ + "static/media/MaterialIcons-Regular.e79bfd88.eot";